"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UA = window.navigator.userAgent.toLowerCase();
exports.isAndroid = /android/i.test(exports.UA);
var isIpad = /ipod|ipad/i.test(exports.UA);
exports.isIOS = /iphone os/i.test(exports.UA) || isIpad;
exports.isFusion = /fusionkit/i.test(exports.UA);
var iosRE = /iphone os ([\d_]+)/i;
var ipadRE = /cpu os ([\d_]+)/i;
var androidRE = /android[ /]([\d.]+)/i;
exports.iosVersion = (function () {
    if (isIpad) {
        return exports.UA.match(ipadRE)[1].replace(/_/g, '.');
    }
    else if (exports.isIOS) {
        return exports.UA.match(iosRE)[1].replace(/_/g, '.');
    }
    return '';
})();
exports.androidVersion = (function () {
    return exports.isAndroid ? exports.UA.match(androidRE)[1] : '';
})();
